import React from 'react';
import Menu from '../components/menuComp';
import Header from '../components/headerComp';
import Footer from '../components/footerComp';
import Carousel from '../components/carrouselComp';
import '../App.css';

const HomePage = () => {
  return (
    <div className="home-container">
      <Header />
      <Menu />
      <Carousel />
      <Footer />
    </div>
  );
};

export default HomePage;
